import React from "react";
import UserProfile from "../Header/UserProfie";
import Notification from "../Header/Notification";

const Header = ({ userData }) => {
  const toggleClass = () => {
    const bodyElement = document.getElementsByTagName("body")[0];
    if (bodyElement.classList.contains("close-siderbar")) {
      bodyElement.classList.remove("close-siderbar");
    } else {
      bodyElement.classList.add("close-siderbar");
    }
  };
  return (
    <header className="header">
      <div className="header-left">
        <div
          className="bar"
          onClick={() => {
            toggleClass();
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div className="header-right">
        <Notification />
        <UserProfile userData={userData} />
      </div>
    </header>
  );
};
export default Header;
